// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"fa66278c","739":"7a2d7697"}[chunkId] + ".chunk.js";
};